import React, { useRef, useState } from 'react';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import websitelogo from '../../../../assets/logos/websitelogo.svg';

import Input from '@mui/material/Input';

import {
	Alert,
	Box,
	Checkbox,
	CssBaseline,
	FormControlLabel,
	Grid,
	Snackbar,
	TextField,
	Typography,
} from '@mui/material';

import Paper from '@mui/material/Paper';

import Button from '@mui/material/Button';

import CallIcon from '@mui/icons-material/Call';

import { useParams } from 'react-router-dom';

import ContactSupportIcon from '@mui/icons-material/ContactSupport';

import { useNavigate, Link, useLocation } from 'react-router-dom';

import { verifyEmail } from '../../../services/api/apiManager';

// const maskEmail = (email) => {
//     const [localPart, domain] = email.split('@');
//     const maskedLocalPart = localPart.substring(0, 3) + '****';
//     return maskedLocalPart + '@' + domain;
// };



function VerificationCode() {
	const defaultTheme = createTheme();
    // const { email }= useParams();
	// const maskedEmail = maskEmail(email);
	const [inputValues, setInputValues] = useState(Array(6).fill(''));
	const navigate = useNavigate();

	const [successSnackbarOpen, setSuccessSnackbarOpen] = useState(false);
	const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
	const [snackbarMessage, setSnackbarMessage] = useState('');
	const [snackbarSeverity, setSnackbarSeverity] = useState('');

	const handleCloseSuccessSnackbar = () => {
		setSuccessSnackbarOpen(false);
	};

	const handleCloseErrorSnackbar = () => {
		setErrorSnackbarOpen(false);
	};

	const handleOpenSuccessSnackbar = (message) => {
		setSnackbarMessage(message);
		setSnackbarSeverity('success');
		setSuccessSnackbarOpen(true);
	};

	const handleOpenErrorSnackbar = (message) => {
		setSnackbarMessage(message);
		setSnackbarSeverity('error');
		setErrorSnackbarOpen(true);
	};

	const textInputRefs = Array(6)
		.fill(null)
		.map(() => useRef(null));

	const handleInputChange = (index, value) => {
		// Limit the input to one digit
		const newValue = value.slice(0, 1);
		const newInputValues = [...inputValues];
		newInputValues[index] = newValue;
		setInputValues(newInputValues);

		// Move focus to the next TextField if not the last one
		if (index < textInputRefs.length - 1 && newValue.length > 0) {
			textInputRefs[index + 1].current.focus();
		}
	};
	const handleSubmit = async () => {
		const code = inputValues.map((value) => parseInt(value, 10)).join('');

		try {
			// Make API call to verify email
			const formData = { code }; // Creating formData object
			const response = await verifyEmail(formData);

			if (response && response?.status===200) {
				handleOpenSuccessSnackbar('Email verification successful');
				setTimeout(() => {
					navigate("/");
				  }, 1500);
				// Perform actions for successful verification
			} else {
				handleOpenErrorSnackbar('Email verification failed');
				// Handle failed verification
			}
		} catch (error) {
			handleOpenErrorSnackbar('Error verifying email');
			// Handle error here
		}
	};
	const handleCloseSnackbar = () => {
		setSnackbarOpen(false);
	};

	return (
		<ThemeProvider theme={defaultTheme}>
			<Grid
				container
				component="main"
				sx={{
					height: '100vh',
					backgroundImage: `url(${require('../../../../assets/images/background.png')})`,
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					padding: '60px',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					'@media (max-width: 600px)': {
						// Styles for xs and sm screens
						padding: '70px 30px',
					},
				}}
			>
				<CssBaseline />

				<Grid
					container
					item
					xl={10}
					lg={10}
					md={12}
					sm={12}
					xs={11}
					justifyContent="center"
				>
					<Grid
						item
						xs={false}
						sm={6}
						md={6}
						lg={5}
						xl={5}
						sx={{
							backgroundImage: `url(${require('../../../../assets/images/singupbacground.png')})`,
							backgroundRepeat: 'no-repeat',
							backgroundPosition: 'center',
							backgroundSize: 'cover',
							display: 'flex',
							flexDirection: 'column',
							borderRadius: '15px 0px 0px 15px',
							justifyContent: 'space-between',
							// background: '#197CCC','
							display: { sm: 'none', xs: 'none', md: 'flex', xl: 'flex' },
						}}
					>
						<Grid
							item
							sx={{
								display: 'flex',
								flex: '1',
								flexDirection: 'column',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<Typography
								variant="h5"
								sx={{
									color: 'white',
									fontSize: '23px',
									fontFamily: 'Poppins',
									fontWeight: '600',
									textAlign: 'center',
								}}
							>
								PROTECTED ACCESS REQUIRED
							</Typography>
							<Typography
								variant="h5"
								sx={{
									color: 'white',
									fontSize: '18px',
									fontFamily: 'Poppins',
									textAlign: 'center',
									fontWeight: '400',
								}}
							>
								Our Commitment to Safeguarding <br /> Your Information
							</Typography>
						</Grid>
						<Grid
							item
							sx={{
								display: 'flex',
								justifyContent: 'space-evenly',
								borderTop: '0.5px solid rgba(255, 255, 255, 0.40)',
								padding: '15px 50px',
							}}
						>
							<Grid
								container
								alignItems="center"
								justifyContent="center"
								spacing={1} // Adjust the spacing as needed
							>
								<Grid item>
									<ContactSupportIcon sx={{ color: 'white' }} />
								</Grid>
								<Grid item>
									<Link to={'/aboutUs'}>
										<Typography
											variant="body1"
											sx={{
												fontSize: '13px',
												color: 'white',
												fontWeight: '700',
												textDecoration: 'underline',
											}}
										>
											About Us
										</Typography>
									</Link>
								</Grid>
							</Grid>

							<Grid
								container
								alignItems="center"
								justifyContent="center"
								spacing={1} // Adjust the spacing as needed
							>
								<Grid item>
									<CallIcon sx={{ color: 'white' }} />
								</Grid>
								<Grid item>
									<Link to={'/contactUs'}>
										<Typography
											variant="body1"
											sx={{
												fontSize: '13px',
												color: 'white',
												fontWeight: '700',
												textDecoration: 'underline',
											}}
										>
											Contact Us
										</Typography>
									</Link>
								</Grid>
							</Grid>
							{/* <Grid
								container
								alignItems="center"
								justifyContent="center"
								spacing={1} // Adjust the spacing as needed
							>
								<Grid item>
									<ChatIcon sx={{ color: 'white' }} />
								</Grid>
								<Grid item>
									<Link to={'/feedback'}>
										<Typography
											variant="body1"
											sx={{
												fontSize: '13px',
												color: 'white',
												fontWeight: '700',
												textDecoration: 'underline',
											}}
										>
											Feedback
										</Typography>
									</Link>
								</Grid>
							</Grid> */}
						</Grid>
					</Grid>
					<Grid
						component={Paper}
						square
						item
						xs={12}
						sm={8}
						md={5}
						lg={5}
						xl={4}
						sx={{
							backgroundImage: `url(${require('../../../../assets/images/formbackground.png')})`,
							backgroundRepeat: 'no-repeat',
							backgroundSize: 'cover',
							backgroundPosition: 'center',
							borderRadius: '0px 15px 15px 0px',
							'@media (max-width: 600px)': {
								// Styles for xs and sm screens
								borderRadius: '15px',
							},
							'@media (max-width: 900px)': {
								// Styles for xs and sm screens
								borderRadius: '15px',
								justifyContent: 'center',
							},
						}}
					>
						<Box
							sx={{
								marginLeft: '30px',
								margin: '30px',
								display: 'flex',
								flexDirection: 'column',
								// alignItems: 'center',
								// justifyContent: 'center',
							}}
						>
							<img
								src={websitelogo}
								alt="Your Alt Text"
								style={{ width: '200px', height: 'auto' }}
							/>
							<Typography
								component="h1"
								variant="h4"
								sx={{
									alignSelf: 'start',
									fontSize: '27px',
									fontWeight: '600',
									marginTop: '20px',
									marginLeft: '10px',
								}}
							>
								Verification Code
							</Typography>
							<Box
								component="form"
								sx={{
									mt: 1,
								}}
							>
								<Typography
									variant="body2"
									sx={{
										color: '#7E7D7D',
										fontFamily: 'Poppins',
										fontSize: '18px',
										marginLeft: '10px',
										color: '#6B6666',
									}}
								>
									Please enter the verification code sent to your email
								</Typography>
								{/* <Typography
									variant="body2"
									sx={{
										fontSize: '18px',
										fontWeight: '600',
										fontFamily: 'Poppins',
										marginLeft: '10px',
										color: '#6B6666',
									}}
								>
									sk*****4
									{maskedEmail}
								</Typography> */}

								<Grid
									container
									direction="row"
									justifyContent="center"
									alignItems="center"
									spacing={2}
									sx={{ marginTop: '50px', marginBottom: '50px' }}
								>
									{[...Array(6)].map((_, index) => (
										<Grid
											item
											key={index}
											xl={1.5}
											lg={1.5}
											md={1.5}
											sm={1.5}
											xs={1.75}
										>
											<Input
												placeholder="0"
												value={inputValues[index]}
												type="text"
												onChange={(e) =>
													handleInputChange(index, e.target.value)
												}
												sx={{
													background: '#C8E0EC',
													borderRadius: '7px',
													textAlign: 'center',
													fontSize: '28px',
													fontWeight: '500',
													color: '#5A5757',
													padding: '0px',
													textDecoration: 'none',
													'& input': {
														textAlign: 'center',
													},
												}}
												fullWidth
												inputRef={textInputRefs[index]}
												InputLabelProps={{
													style: {
														padding: '0px',
													},
												}}
												disableUnderline
											/>
										</Grid>
									))}
								</Grid>

								<Button
									variant="filled"
									onClick={() => handleSubmit()}
									fullWidth
									sx={{
										background: '#e87511',
										color: 'white',
										borderRadius: '6px',
										height: '50px',
										width: '100%',
										fontSize: '20px',
										fontWeight: '600',
										marginTop: '25px',
										border: ' 2px solid #E87511',
										'&:hover': {
											borderColor: '#e87511',
											color: '#e87511',
										},
									}}
								>
									CONTINUE
								</Button>
							</Box>
						</Box>
					</Grid>
				</Grid>
				<Snackbar
					open={successSnackbarOpen}
					autoHideDuration={6000}
					onClose={handleCloseSuccessSnackbar}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				>
					<Alert
						onClose={handleCloseSuccessSnackbar}
						severity="success"
						sx={{
							background: 'green',
							color: 'white',
							fontFamily: 'Poppins',
							fontSize: '18px',
						}}
					>
						{snackbarMessage}
					</Alert>
				</Snackbar>
				<Snackbar
					open={errorSnackbarOpen}
					autoHideDuration={6000}
					onClose={handleCloseErrorSnackbar}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				>
					<Alert
						onClose={handleCloseErrorSnackbar}
						severity="error"
						sx={{
							background: 'red',
							color: 'white',
							fontFamily: 'Poppins',
							fontSize: '18px',
						}}
					>
						{snackbarMessage}
					</Alert>
				</Snackbar>
			</Grid>
		</ThemeProvider>
	);
}
export default VerificationCode;
